/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrient_CarbsInputs */

const en_nutrient_carbs = /** @type {(inputs: Nutrient_CarbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carbs`)
};

const de_nutrient_carbs = /** @type {(inputs: Nutrient_CarbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohlenhydrate`)
};

/**
* | output |
* | --- |
* | "Carbs" |
*
* @param {Nutrient_CarbsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrient_carbs = /** @type {((inputs?: Nutrient_CarbsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrient_CarbsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrient_carbs(inputs)
	return en_nutrient_carbs(inputs)
});